
















































import Header from "@/layout/Header.vue";
import Footer from "@/layout/Footer.vue";
import WrapLogin from "@/views/Home/WrapLogin.vue";
import SectionContainer from "@/views/Home/SectionContainer.vue";
import FAQCollapseCard from "@/views/Home/FAQCollapseCard.vue";
import DocumentValidateInput from "@/views/Home/DocumentValidateInput.vue";
import SuiteNumbers from "@/views/Home/SuiteNumbers.vue";
import AttendanceChannel from "@/views/Home/AttendanceChannel.vue";
import Carousel from "@/components/Carousel";
import { App, Home } from "@/utils/constants";

export default {
  name: "Home",
  components: {
    AttendanceChannel,
    DocumentValidateInput,
    SuiteNumbers,
    Header,
    Footer,
    WrapLogin,
    SectionContainer,
    FAQCollapseCard,
    Carousel
  },
  data() {
    return {
      App,
      Home,
      linksHelp: [
        {
          icon: "home-account",
          name: "Primeiros passos",
          url: "https://suite.seplag.ce.gov.br/?cat=1"
        },
        {
          icon: "plus-circle",
          name: "Iniciar processos",
          url: "https://suite.seplag.ce.gov.br/?cat=2"
        },
        {
          icon: "text-search",
          name: "Consulta de processos",
          url: "https://suite.seplag.ce.gov.br/?cat=3"
        },
        {
          icon: "gesture-tap-button",
          name: "Ações no processo",
          url: "https://suite.seplag.ce.gov.br/?cat=4"
        },
        {
          icon: "file-document-multiple",
          name: "Documentos do Processo",
          url: "https://suite.seplag.ce.gov.br/?cat=5"
        },
        {
          icon: "pen-lock",
          name: "Assinaturas de Documento",
          url: "https://suite.seplag.ce.gov.br/?cat=6"
        },
        {
          icon: "plus-thick",
          name: "Ver tudo",
          url: "https://suite.seplag.ce.gov.br",
          round: true
        }
      ]
    };
  }
};
